const Backup = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#646464"
      d="M16.003 16.747a5.007 5.007 0 0 1-3 .994 5.04 5.04 0 0 1-5.034-5.034V3.214l2.683 2.682a.472.472 0 0 0 .667 0l.222-.222a.472.472 0 0 0 0-.668L7.674 1.138a.472.472 0 0 0-.668 0L3.138 5.006a.472.472 0 0 0 0 .668l.223.222a.472.472 0 0 0 .667 0l2.683-2.682v9.493A6.3 6.3 0 0 0 13.004 19a6.26 6.26 0 0 0 3.79-1.273.473.473 0 0 0 .05-.712l-.224-.224a.472.472 0 0 0-.617-.044Z"
    />
  </svg>
)
export default Backup
